import { API } from 'aws-amplify';

interface customInstanceProperties {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  params?: Record<string, string | number | string[]>;
  headers?: Record<string, string>;
  data?: unknown;
  responseType?: string;
}

const customInstance = async <T>(
  apiName: string,
  { url, method, params, headers, data }: customInstanceProperties,
): Promise<T> => {
  if (method === 'GET') {
    return (await API.get(
      apiName,
      url +
        '?' +
        new URLSearchParams(
          params as Record<string, string> | undefined,
        ).toString(),
      { headers },
    )) as T;
  } else if (method === 'POST') {
    return (await API.post(
      apiName,
      url +
        '?' +
        new URLSearchParams(
          params as Record<string, string> | undefined,
        ).toString(),
      {
        body: data,
        headers: headers,
      },
    )) as T;
  } else if (method === 'PUT') {
    return (await API.put(
      apiName,
      url +
        '?' +
        new URLSearchParams(
          params as Record<string, string> | undefined,
        ).toString(),
      {
        body: data,
        headers: headers,
      },
    )) as T;
  } else if (method === 'PATCH') {
    return (await API.patch(
      apiName,
      url +
        '?' +
        new URLSearchParams(
          params as Record<string, string> | undefined,
        ).toString(),
      {
        body: data,
        headers: headers,
      },
    )) as T;
  } else if (method === 'DELETE') {
    return (await API.del(
      apiName,
      url +
        new URLSearchParams(
          params as Record<string, string> | undefined,
        ).toString(),
      { headers },
    )) as T;
  }

  throw Error(`Unsupported method ${method}`);
};

export const customAdminApiInstance = async <T>(
  props: customInstanceProperties,
): Promise<T> => {
  return customInstance<T>('admin-api', props);
};

export const customAnalyticsApiInstance = async <T>(
  props: customInstanceProperties,
): Promise<T> => {
  return customInstance<T>('analytics-api', props);
};
